import { CompactUserResponse } from '../account';
import { OrgId } from '@business/entities/organization';
import { LabourTypeResponse } from '../labour-type';

export type TimeLogId = string;

export enum TimeLogStatus {
  started = 'started',
  completed = 'completed',
}

export enum TimelogBillable {
  billable = 1,
  notBillable = 0,
}

export enum TimeLogType {
  ticket = 'ticket',
  ticketTask = 'ticketTask',
  projectTask = 'projectTask',
  tm = 'tm',
  project = 'project',
}

export enum TimeLogFilterType {
  user = 'user',
  org = 'org',
}

export enum TimeLogWorkType {
  technical = 'technical',
  independent = 'independent',
}

export interface TimeLogResponse {
  id: TimeLogId;
  type: TimeLogType;
  objectId: string;
  time: number;
  status: TimeLogStatus;
  createdAt: number;
  hours: number;
  labourType: LabourTypeResponse;
  forDate: number;
  notes: string;
  objectTitle: string;
  orgId: OrgId;
  orgName?: string;
  user: CompactUserResponse;
  stoppedBy?: CompactUserResponse;
  isManual: boolean;
  canEdit: boolean;
  checkoutTime: number;
  isOwner: boolean;
  link: string;
  objectSubtitle?: string;
  parentId?: string;
  parentType?: TimeLogType;
  isBillable: TimelogBillable;
  workType?: TimeLogWorkType | string | null;
}

export type ManualTimeLogRequest = {
  minutes: number;
  date: number;
  notes: string;
  isBillable?: TimelogBillable;
  workType?: TimeLogWorkType | string | null;
};

export interface OpenTimeLogResponse {
  id: TimeLogId;
  objectTitle: string;
  createdAt: number;
  forDate: number;
  time: number;
}

export interface sendEmailTimeTrackingRequest {
  to: string[];
  cc: string[];
  bcc: string[];
  body: string;
}
